import { IonToast } from '@ionic/react';
import { useIntl } from 'react-intl';

interface ConfirmToastProps {
  showToast: boolean;
  hideToast: Function;
  onCancel: Function;
  onAccept: Function;
  acceptText: string;
  refusedText: string;
  messageText: string;
}

export const ConfirmToast: React.FC<ConfirmToastProps> = ({
  showToast,
  hideToast,
  onCancel,
  onAccept,
  acceptText,
  refusedText,
  messageText,
}) => {
  const intl = useIntl();

  return (
    <IonToast
      isOpen={showToast}
      onDidDismiss={() => hideToast(false)}
      message={intl.formatMessage({ id: messageText })}
      position="top"
      buttons={[
        {
          side: 'start',
          text: intl.formatMessage({ id: acceptText }),
          handler: () => {
            onAccept();
          },
        },
        {
          text: intl.formatMessage({ id: refusedText }),
          role: 'cancel',
          handler: () => {
            onCancel();
          },
        },
      ]}
    />
  );
};
